/* @flow */
import idx from 'idx';
import React from 'react';
import { pick } from 'lodash';
import { graphql } from 'react-apollo';

import GET_PROVIDER_OAUTH_CONFIG_QUERY from '../queries/LinkedAccountProviderOauthConfigQuery.gql';
import UPDATE_OAUTH_CONFIG_MUTATION from '../queries/UpdateOauthConfigMutation.gql';

import type { LinkedAccountProviderOauthConfigContainer as LinkedAccountProviderOauthConfigContainerQuery } from '../queries/__generated__/LinkedAccountProviderOauthConfigContainer';

type Props = {
  uuid: string,
  mutate: Function,
  children: Function,
  data: ReactApolloData<LinkedAccountProviderOauthConfigContainerQuery>,
};

const UPDATABLE = ['scopes', 'authUrl', 'tokenUrl', 'clientId', 'clientSecret'];

const DEFAULTS = {
  scopes: [],
  authUrl: '',
  clientId: '',
  tokenUrl: '',
  providerKey: '',
  clientSecret: '',
  organizationUUID: '',
};

class LinkedAccountProviderOauthConfigContainer extends React.Component<Props, {}> {
  update = (attributes: *) => {
    const mutationInput = pick(
      {
        ...DEFAULTS,
        ...(this.getLinkedAccountProviderOauthConfig() || {}),
        ...attributes,
      },
      UPDATABLE
    );

    return this.props
      .mutate({
        variables: {
          input: {
            ...mutationInput,
            organizationUUID: this.props.uuid,
            providerKey: this.getProviderKey(),
          },
        },
      })
      .then(result => {
        const error = idx(result, _ => _.data.updateLinkedAccountProviderOauthConfig.error.message);

        if (error) {
          throw new Error(error);
        } else {
          return result;
        }
      });
  };

  getLinkedAccountProviderOauthConfig = () => {
    return idx(this.props, _ => _.data.linkedAccountProviderOauthConfig);
  };

  getProviderKey = () => {
    return idx(this.props, _ => _.data.contentSourceProvider.providerKey);
  };

  render() {
    return this.props.children({
      linkedAccountProviderOauthConfig: this.getLinkedAccountProviderOauthConfig(),
      contentSourceProviderKey: this.getProviderKey(),
      loading: this.props.data.loading,
      update: this.update,
    });
  }
}

const withTheLinkedAccountProviderOauthConfigMutation = graphql(UPDATE_OAUTH_CONFIG_MUTATION);

const withTheLinkedAccountProviderOauthConfig = graphql(GET_PROVIDER_OAUTH_CONFIG_QUERY, {
  options: ({ uuid }) => ({
    fetchPolicy: 'network-only',
    variables: { uuid },
  }),
});

export { LinkedAccountProviderOauthConfigContainer };
export default withTheLinkedAccountProviderOauthConfigMutation(
  withTheLinkedAccountProviderOauthConfig(LinkedAccountProviderOauthConfigContainer)
);
